.
<template>
  <div class="w-auto h-auto mt-4">
    <img class="mx-4 w-11/12 h-1/3 rounded-2xl" :src="imgUrl" alt="">
  </div>
</template>

<script>
export default {
  name: 'Welcome1Content',
  data() {
    return {
      imgUrl: new URL('@/assets/images/welcome-preview.jpg', import.meta.url).href,
      videoIconUrlrequire: new URL('@/assets/videos/GT_Enroll_intro_video.mp4', import.meta.url).href + "#t=0.6",
    };
  },
};
</script>

<style></style>
